import { Outlet } from 'react-router-dom'
import React from 'react'
import './App.scss'

function App() {
    return (
        <div className="App">
            <Outlet />
        </div>
    )
}

export default App
